module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('boxWrap', {
    attrs: {
      "name": _vm.name,
      "min": true
    }
  }, [_c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "list-item list-item1"
  }, [_c('div', {
    staticClass: "item"
  }, [_vm._v("种植批次")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("生产总重量")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("报损率")])]), _vm._v(" "), (_vm.tableData.length != 0) ? _c('swiper', {
    ref: "mySwiper",
    staticClass: "swiper-wrap",
    attrs: {
      "options": _vm.swiperOption
    }
  }, _vm._l((_vm.tableData), function(item, index) {
    return _c('swiper-slide', {
      key: index,
      staticClass: "list-item"
    }, [_c('div', {
      staticClass: "item name"
    }, [_vm._v(_vm._s(item.traceBatchName))]), _vm._v(" "), _c('div', {
      staticClass: "item"
    }, [_vm._v(_vm._s(item.harvestQuantity))]), _vm._v(" "), _c('div', {
      staticClass: "item"
    }, [_vm._v(_vm._s(item.damagedRatio) + "%")])])
  }), 1) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5bfe79f8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/runda/tourupin/components/planting/index.vue
// module id = 2010
// module chunks = 2